import React from 'react';
import axios from 'axios';

const UserCell = ({ sale, selectedSectionId, onSelectUser }) => {
  return (
    <div key={sale.id} className={`chat-user-item ${selectedSectionId === sale.id ? 'active' : ''}`} onClick={() => {
      onSelectUser(sale);
    }}>
      <div className="chat-user-row row">
        <div className="chat-avatar col-xl-2 col-3">
          <div className="chat-avatar-mode">
            <img src={`${axios.defaults.baseURL}userimage/${sale.user.image}`} className="rounded-circle size-40" alt={sale.serial_no} />
            <span className={`chat-mode small ${sale.refund}`} />
          </div>
        </div>

        <div className="chat-info col-xl-6 col-4">
          <span className="name h4">{sale.serial_no}</span>
          <div className="last-message-time">
            {sale.customer !== null ? (
              sale.customer.name
            ) : ""}
          </div>
        </div>


        <div className="chat-date col-xl-2 col-2 d-flex ">
          {sale.refund === 1 ? (
            <div className="bg-primary rounded-circle badge text-white">R</div>
          ) : ""}

          {sale.payprove === 1 ? (
            sale.type === 1 ? (
              sale.paid !==null ?(
                <div className="rounded-circle badge text-white" style={{ backgroundColor: '#ff9800' }}>P</div>
              ):''
            
            ) : ''

          ) : ""}

          {sale.paid < sale.total ? (
            sale.type === 1 ? (
              <div className="rounded-circle badge text-white" style={{ backgroundColor: '#f6f436' }}>U</div>
            ) : ''
          ) : ""}

          {sale.edit[0]?.status === 1 ? (
            <div className="rounded-circle badge text-white" style={{ backgroundColor: '#ffc107' }}>E</div>
          ) : ""}

        </div>



      </div>
    </div>
  )
};

export default UserCell;